var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q-color-svpanel",style:(_vm.rootStyles)},[_c('div',{staticClass:"q-color-svpanel__cursor",style:(_vm.cursorStyles)})])}
var staticRenderFns = []

export { render, staticRenderFns }